import store from './store';

export default ({ data, cacheKey }) => store.dispatch({
  type: `${cacheKey}:RESOLVED`,
  payload: data,
});
